<p class="text-title-lgx-bold">Información básica</p>
<p class="text-info-bold-xs mt-xxs mb-xlg">¡CUENTANOS UN POCO MÁS SOBRE TI!</p>
<div class="container-logo-name mt-xlg tw-w-full tw-flex tw-flex-col tw-gap-4 md:tw-flex-row">
  <div class="tw-w-full md:tw-w-1/4">
    <p class="text-info mb-xs">IMAGEN DE PERFIL</p>
    <div class="box-drop-logo cursor-pointer"
      [class.drag-enter]="dragEnter"
      nz-popover="" nzPopoverTitle="" [nzPopoverContent]="url ? 'Clic para cambiar la imagen' : ''"
      (click)="input.click()" (drop)="onDropImageProfile($event)" (dragover)="allowDrop($event)" (dragenter)="onDragEnter()"
      (dragleave)="onDragLeave()">
      <p *ngIf="!url" @fadeInAnimation class="text-regular-14 logo-drop-text">Arrastra tu imagen o da clic aquí</p>
      <div *ngIf="url" @fadeInAnimation class="container-image-selected">
        <img loading="lazy" [src]="this.url" alt="" style="max-width: 100%;">
      </div>
      <input
        #input
        type="file"
        accept="image/*"
        (change)="onSelectImageProfile($event.target['files'])"
        style="display: none"
        />
    </div>
  </div>
  <div class="tw-w-full md:tw-w-3/4">
    <form nz-row novalidate
      #form="ngForm">
      <div nz-col nzSpan="24">
        <!--Content-->
        <div class="address-container mb-sm tw-flex tw-flex-col tw-gap-4 md:tw-flex-row">
          <div class="tw-w-full md:tw-w-1/2 tw-flex tw-flex-col tw-justify-end">
            <div class="text-info-upper mb-xs">¿Cuál es tu fecha de nacimiento?</div>
            <nz-date-picker
              [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY"
              [(ngModel)]="birthday"
              #ngbirthday="ngModel"
              [required]="true"
              name="ngbirthday"
              [nzDisabledDate]="utilityService.disabledDate"></nz-date-picker>
            <app-message-field [field]="ngbirthday"></app-message-field>
          </div>
          <div class="tw-w-full md:tw-w-1/2 tw-flex tw-flex-col tw-justify-end">
            <div class="text-info-upper mb-xs">¿Cuál es tu sexo?</div>
            <nz-select
              [(ngModel)]="gender"
              [required]="true"
              name="ngGender"
              nzPlaceHolder="Seleccione"
              #ngGender="ngModel">
              <nz-option [nzValue]="this.genderEnum.MALE" nzLabel="Masculino"></nz-option>
              <nz-option [nzValue]="this.genderEnum.FEMALE" nzLabel="Femenino"></nz-option>
            </nz-select>
            <app-message-field [field]="ngGender"></app-message-field>
          </div>
        </div>
        <!-- / Content-->
      </div>
    </form>
  </div>
</div>
